import type { ImageRef } from './types';

export const compareHero = {
  title: 'Compare rates',
  cta: { label: 'Get the app', href: '/get-the-app' },
};

export interface CompareStep {
  image: ImageRef;
  title: string;
  description: string;
}

export const compareSteps: CompareStep[] = [
  {
    image: {
      src: '/images/compare/step-amount.jpg',
      alt: 'Entering an amount to send in the nsave app',
    },
    title: 'Enter the amount',
    description:
      'Type in how much you want to send and see exactly what lands on the other side. Live rates, what you enter is what they get.',
  },
  {
    image: {
      src: '/images/compare/step-recipient.jpg',
      alt: 'Choosing a recipient in the nsave app',
    },
    title: 'Add recipient',
    description:
      'Pick someone from your contacts or add a new recipient in seconds. Save them once, and every transfer after that takes just a tap.',
  },
  {
    image: {
      src: '/images/compare/step-receive.jpg',
      alt: 'Receiving local currency in the nsave app',
    },
    title: 'Receive your local currency',
    description:
      'Your money arrives as local currency, straight to their account and ready to spend. Fast delivery, low fees, and our best exchange rate every time.',
  },
];
